<template>
  <v-layout wrap class="mx-3 mt-2 list-section">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12 sm12>
          <v-spacer></v-spacer>
          <v-btn dark small right class="red right" to="/sonko/jobs/active">
            <v-icon left>close</v-icon>Close
          </v-btn>
        </v-flex>
        <v-flex xs12 sm12 v-if="jobError != ''" class="mb-2">
          <span
            style="color: #b71c1c;"
          >{{ jobError }}</span>
        </v-flex>
        <v-flex xs12 sm12>
          <v-text-field
            v-validate="'required'"
            :error-messages="errors.collect('title')"
            data-vv-name="title"
            v-model="job.title"
            label="Job Title"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm12>
          <label>Job Description</label>
          <tinymce 
            id="description"
            data-vv-name="description"
            v-model="job.description"
            label="Job Description"
            :other_options="tinyOptions"
          ></tinymce>
        </v-flex>
        <v-flex xs12 sm12 v-if="tinymcError != ''" class="mb-2">
          <span class="v-messages theme--light error--text"><strong>Min allowed text is 60 words. Please add more details about your job.</strong> </span>
          <!-- <span class="red--text" > THE MORE THE CONTENT THE BETTER THE INDEXING!</span> -->
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            v-validate="'required'"
            :error-messages="errors.collect('timeFrame')"
            data-vv-name="timeFrame"
            v-model="job.timeFrame"
            label="Work Urgency"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4>
          <v-autocomplete
            v-validate="'required'"
            :error-messages="errors.collect('category')"
            data-vv-name="category"
            :items="categories"
            v-model="job.category"
            v-on:input="getSubCategory(`${job.category}`)"
            label="Type the Job Expertise Required"
            single-line
            item-text="category"
            item-value="category"
            required
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-autocomplete
            :items="subcategories"
            v-model="subcategory"
            label="Sub Category"
            single-line
            item-text="name"
            required
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 sm6 v-if="editStatus=='editing'">
          Current Location: {{job.location.locationName}}
          <div v-if="locationName!=null">
            <span style="color: green">{{locationName}}</span>
            <v-btn @click="clearLocation()" icon>
              <v-icon color="red">clear</v-icon>
            </v-btn>
          </div>
          <u-location-modal v-else @data="setLocation"></u-location-modal>
        </v-flex>
        <v-flex xs12 sm6 v-else>
          <div v-if="locationName!=null">
            Selected Location:
            <span style="color: green">{{locationName}}</span>
            <v-btn @click="clearLocation()" icon>
              <v-icon color="red">clear</v-icon>
            </v-btn>
          </div>
          <location-modal v-else @data="setLocation"></location-modal>
        </v-flex>
        <!-- cover image upload -->
        <v-flex xs12 sm12>
          <label>Only Image Upload (You need to multi-select images first. Maximum of 5 images, Maximum size 10MB per image). You can add more images later. </label><label class="red--text">PLEASE DO NOT UPLOAD PHOTOS WITH YOUR PHONE OR EMAIL CONTACTS</label>
          <v-alert :value="true" v-if="fileerror==true" type="error" class="py-2">Uploaded files must be 5 max & images in format & each not to exceed 10MB</v-alert>
          <div class="text-xs-center text-md-left">
            <multiple-file-upload @collection="setImages" @urls="setImagesUrls"></multiple-file-upload>
          </div>
        </v-flex>

        <v-flex xs12 sm3 v-for="(url, key) in imagesUrls" v-bind:key="key">
          <v-btn icon @click="removeImage(key)">
            <v-icon color="red">clear</v-icon>
          </v-btn>
          <img v-if="url" :src="url" style="width: 150px; height: 150px; padding: 20px">
        </v-flex>

        <v-flex xs12 class="text-xs-center text-md-right">
          <v-btn class="primary" dark @click="save">
            <v-icon left>save</v-icon> Save
          </v-btn>
        </v-flex>

        <v-flex xs12 v-if="job.images && job.images.length > 0">
          <label>Images</label>
          <v-layout wrap>
            <v-flex xs12 sm3 v-for="(image, index) in job.images" v-bind:key="index" class="pa-2">
            <v-btn icon @click="deleteImage(index)">
              <v-icon color="red">clear</v-icon>
            </v-btn>
            <v-img v-if="image" :src="`${host}/uploads/jobs/${image}`"></v-img>
          </v-flex>
          </v-layout> 
        </v-flex>

        
      </v-layout>
    </v-container>
    <!-- snackbar -->
    <snackbar ref="mySnackbar"></snackbar>
    <!-- end of snackbar -->
  </v-layout>
</template>

<script>
import Snackbar from "@/components/global/snackbar.vue";
import FileUpload from "@/components/shared/file-uploader.vue";
import MultipleFileUpload from "@/components/shared/multiple-file-uploader.vue";
import LocationModal from "./location_modal.vue";
import ULocationModal from "./u_location_modal.vue";
import { mapGetters } from "vuex";
import tinymce from 'vue-tinymce-editor';
export default {
  name: "JobsEditor",
  props: {
    initial: {
      type: Object,
      default: {}
    },
    editStatus: {
      type: String,
      default: "newRecord"
    },
    jobError: {
      type: String,
      default: ''
    }
  },
  components: {
    FileUpload,
    MultipleFileUpload,
    LocationModal,
    ULocationModal,
    Snackbar,
    tinymce
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["host"])
  },
  data() {
    return {
      title: null,
      description: null,
      timeFrame: null,
      categories: [],
      subcategories: [],
      category: null,
      subcategory: null,
      job: {},
      editing: null,
      images: [],
      imagesUrls: [],
      location: null,
      locationName: null,
      fileerror: false,
      tinyOptions: {
        menubar:false,
        toolbar1:"formatselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | numlist bullist | removeformat",
        branding: false
      },
      tinymcError: '',
    };
  },
  watch: {
    initial: {
      handler: "setJob",
      immediate: true
    },
    editStatus: {
      handler: "setStatus",
      immediate: true
    }
  },
  methods: {
    removeImage(key) {
      this.imagesUrls.splice(key, 1);
      this.images.splice(key, 1);
    },
    deleteImage(index) {
      this.job.images.splice(index, 1);
      const data = { images: this.job.images };
      const self = this;
      const id = this.job._id;
      const res = this.$store
        .dispatch("put", { url: "/job/delete/image/" + id, data })
        .then(res => {
          //location.reload();
        })
        .finally(() => {});
    },
    setJob(val) {
      const job = this.job;
      this.job = { ...job, ...val };
    },
    setStatus(val) {
      this.editing = val;
      if (val == "editing") {
        this.location = this.job.location;
      }
    },
    getCategories() {
      this.$store.dispatch("get", "/expertise").then(res => {
        this.categories = res.expertiseCategories;
      });
    },
    getSubCategory(title) {
      this.subcategories = [];
      const data = this.categories.find(record => {
        return record.title === title;
      });
      const qcategories = data.subcategories;
      if (qcategories) {
        qcategories.map(record => {
          const newRecord = { name: record };
          this.subcategories.push(newRecord);
        });
      }
    },
    clearLocation() {
      this.locationName = null;
    },
    setImages(files) {
      this.images = files;
    },
    setImagesUrls(urls) {
      this.fileerror = false;
      let imageUrls = [];
      urls.forEach((url, index) => {
        const bytes = (this.calculateImageSize(url));
        let mimeType = url.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
        let allowedMimeType = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/gif', 'image/tiff', 'image/webp', 'image/bmp']
        if(allowedMimeType.includes(mimeType) & bytes<=10) {
          imageUrls.push(url);
        } else {
          this.fileerror = true;
        }
      });
      this.imagesUrls = imageUrls;
    },
    calculateImageSize(base64String){
      let padding, inBytes, base64StringLength;
      if(base64String.endsWith("==")) padding = 2;
      else if (base64String.endsWith("=")) padding = 1;
      else padding = 0;

      base64StringLength = base64String.length;
      inBytes =(base64StringLength / 4 ) * 3 - padding;
      this.kbytes = inBytes / 1000;
      return this.kbytes / 1000;
    },
    setLocation(data) {
      this.location = data.location;
      this.locationName = data.location.locationName;
    },
    save() {
      const self = this;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {  
          var count = this.countWords();        
          if(this.job.description == undefined || this.job.description == null || this.job.description.length == 0){
            this.$refs.mySnackbar.show("Please enter job description", "red");
          } else if(count < 60) {
            this.tinymcError = 'min word error';
          } else {
            this.tinymcError = '';
            if (this.location == undefined || this.location == null) {
              this.$refs.mySnackbar.show("Please select location", "red");
            } else {
              let total = 0;
              if(this.job.images != undefined) {
                total = (this.job.images.length + this.images.length);
              }
              if (this.images.length > 5 || total > 5) {
                this.$refs.mySnackbar.show(
                  "You can not upload more than 5 images... Upload Again '5 or Less Images'",
                  "red"
                );
              } else {
                const data = {
                  userId: this.user._id,
                  title: this.job.title,
                  description: this.job.description,
                  timeFrame: this.job.timeFrame,
                  location: this.location,
                  locationName: this.locationName,
                  category: this.job.category,
                  subcategory: this.subcategory
                };
                const formData = new FormData();

                // other images
                const files = this.images;
                files.forEach((file, index) => {
                  const m_file = file;
                  let bytes = file.size;
                  let mimeType = file.type;
                  let allowedMimeType = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/gif', 'image/tiff', 'image/webp', 'image/bmp']
                  if(allowedMimeType.includes(mimeType) & bytes<=10*1024*1024) {
                    if (this.editing == "editing") {
                      formData.append("otherImages", m_file);
                    } else {
                      formData.append("images", m_file);
                    }
                  }
                });
                // end of other images
                if (this.editStatus == "editing") {
                  formData.append("options", JSON.stringify(data));
                  const details = { formData: formData, id: self.job._id };
                  this.$emit("edata", details);
                } else {
                  formData.append("data", JSON.stringify(data));
                  this.$emit("data", formData);
                }
              }
            }
          }
        }
      });
    },
    countWords() {
        const wordcount = window.tinymce.activeEditor.plugins.wordcount;
        return wordcount.getCount();
        /*var body = window.tinymce.get("description").getBody();
        var content = window.tinymce.trim(body.innerText || body.textContent);
        return content.length;*/
    },
  },
  created() {
    this.getCategories();
  }
};
</script>

